import apiClient from './client';

const BASE = '/notifications';

export const getNotifications = async () => {
  const response = await apiClient.get(`${BASE}/`);
  return response.data?.results ?? response.data ?? [];
};

export const getUnreadCount = async () => {
  const response = await apiClient.get(`${BASE}/unread-count/`);
  return response.data?.count ?? 0;
};

export const markNotificationRead = async (id) => {
  const response = await apiClient.patch(`${BASE}/${id}/read/`);
  return response.data;
};

export const markAllNotificationsRead = async () => {
  const response = await apiClient.patch(`${BASE}/read-all/`);
  return response.data;
};
